import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import Input from '../common/Input';
import MaskedInput from '../common/MaskedInput';
import Textarea from '../common/Textarea';
import { leadService } from '../../services/leadService';

// Modal usado em lojas businessType='catalog'. Coleta nome/telefone do
// cliente final + itens de interesse, chama POST /api/leads e abre wa.me.
const LeadInterestModal = ({ open, onClose, items = [], onSuccess }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const canSubmit = name.trim().length >= 2 && phone.trim().length >= 8 && items.length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setLoading(true);
    setErr(null);
    try {
      const payload = {
        customerName: name.trim(),
        customerPhone: phone.trim(),
        customerEmail: email.trim() || null,
        message: message.trim() || null,
        items: items.map((it) => ({
          productVariationId: it.variation.id,
          quantity: it.quantity,
        })),
      };
      const { whatsappUrl, lead } = await leadService.create(payload);
      if (whatsappUrl) {
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      }
      onSuccess?.(lead);
      onClose();
    } catch (e) {
      setErr(e.message || 'Erro ao enviar interesse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="Tenho interesse"
      footer={
        <>
          <Button type="button" variant="subtle" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit} loading={loading} disabled={!canSubmit}>
            Abrir WhatsApp
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-sm text-app-text-secondary">
          Preencha seus dados — abriremos uma conversa no WhatsApp com a loja contendo os produtos
          escolhidos.
        </p>

        <Input
          label="Seu nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          placeholder="Como podemos te chamar?"
        />

        <MaskedInput
          label="Telefone (WhatsApp)"
          mask="phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
          placeholder="(11) 99999-9999"
        />

        <Input
          label="Email (opcional)"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="seu@email.com"
        />

        <Textarea
          label="Mensagem (opcional)"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={3}
          placeholder="Alguma dúvida ou preferência?"
        />

        {items.length > 0 && (
          <div className="bg-app-surface p-3 rounded-lg text-sm">
            <p className="font-medium text-app-text mb-1">Você está interessado em:</p>
            <ul className="space-y-0.5 text-app-text-secondary">
              {items.map((it) => (
                <li key={it.variation.id}>
                  {it.quantity}×{' '}
                  {it.variation.name || Object.values(it.variation.attributes || {}).join(' - ')}
                </li>
              ))}
            </ul>
          </div>
        )}

        {err && (
          <div className="bg-error/10 border border-error/30 text-error px-3 py-2 rounded-lg text-sm">
            {err}
          </div>
        )}
      </form>
    </Modal>
  );
};

export default LeadInterestModal;
